export const productType = {
  SET_PRODUCT_TYPE: "SET_PRODUCT_TYPE",
};
